import { Injectable } from '@angular/core';
import { UtilitesService, mlApiError } from '@systemic/services';
import { Observable } from 'rxjs/Observable';
import { Validate_SignIn_Otp_Response, Request_SignInOtp_Response } from './auth.modal';
import { HttpHeaders } from '@angular/common/http';
import { requestServer, requestType } from '@systemic/interface';

@Injectable()
export class AuthService {
  private reqOtpResp: Request_SignInOtp_Response;
  private valOtpResp: Validate_SignIn_Otp_Response
  constructor(private lib: UtilitesService) { }
  SyncAuthKey(): Observable<boolean> {
    let header = new HttpHeaders().set('X-XSRF-TOKEN', this.lib.cookie.get('XSRF-TOKEN'));
    return this.lib.http.get<string>('/api/auth/sync-key', {
      RequestServer: requestServer.Other,
      Headers: header,
      RequestType: requestType.Anonymus
    }).map(res => {
      if (res.result) {
        return true;
      } else {
        return false;
      }
    }).catch(e => {
      if (e.error) {
        this.lib.notify.error(e.error.message);
      } else if (e instanceof mlApiError) {
        this.lib.notify.error(e.message);
      }
      return Observable.throw(e);
    });
  }

  Req_Sigin_Otp(mobile: string): Observable<Request_SignInOtp_Response> {
    return this.lib.http.get<Request_SignInOtp_Response>(`/web/auth/request-siginin-otp/${mobile}`, {
      RequestType: requestType.Guest
    }).map(res => {
      this.reqOtpResp = res.result; return res.result || {};
    }).catch(e => {
      const message = e.error ? e.error.message : e.message;
      this.lib.notify.error(message);
      return Observable.throw(e);
    });
  }

  get otpReqUser() {
    return this.reqOtpResp || null;
  }
  set otpReqUser(v) {
    this.reqOtpResp = v;
  }

  Val_Sigin_Otp(Otp: string): Observable<Validate_SignIn_Otp_Response> {
    return this.lib.http.get<Validate_SignIn_Otp_Response>(`/web/auth/validate-siginin-otp/${this.reqOtpResp.Mobile}/${Otp}`, {
      RequestType: requestType.Guest
    }).map(res => res.result || {}).catch(e => {
      const message = e.error ? e.error.message : e.message;
      this.lib.notify.error(message);
      return Observable.throw(e);
    });
  }
  Val_Api_Key(): Observable<boolean> {
    return this.lib.http.get<boolean>(`/web/auth/validate/user`).map(res => res.result)
      .catch(e => {
        return Observable.throw(false);
      });
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@service/auth/auth.service.ts